/* eslint-disable import/no-anonymous-default-export */

import Translation from './Translation';

export default {
    Translation
}